import { createFileRoute } from '@tanstack/react-router'

import { RolesPage } from '#/modules/roles/roles-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/roles/')({
  component: RolesPage,
  validateSearch: validateListSearch,
})
